<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlDetailField',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('label')">{{ label }}</div>
    <div :class="bem('text')"><slot /></div>
  </div>
</template>

<script lang="ts" setup name="TlDetailField">
import { createNamespace } from '@bd/vue3-utils'

defineProps<{
  label?: string
}>()
const [_, bem] = createNamespace('TlDetailField')
</script>

<style lang="less">
.tl-detail-field {
  margin-bottom: @margin-sm;

  &__label {
    margin-bottom: @margin-xss;
    color: @text-color-secondary;

    &::after {
      content: '：';
    }
  }

  &__text {
    &:empty {
      &::after {
        color: @text-color-secondary;
        content: '-';
      }
    }
  }
}
</style>
